import { useEffect } from 'react';

const useOutsideClick = (refOrRefs, onClick) => {
  const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isInside = refs.some((ref) => ref?.current?.contains(event.target));
      if (!isInside) onClick?.();
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [...refs, onClick]);
};

export { useOutsideClick };
